import { render, staticRenderFns } from "./_forecastOXTList.vue?vue&type=template&id=e8aea56c&lang=pug&"
import script from "./_forecastOXTList.vue?vue&type=script&lang=js&"
export * from "./_forecastOXTList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports